import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
  ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException,
  NoDataException34qvcinicy2ih as NoDataException,
} from '../exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      static q44(operation, requestUuid, data, errors, extensions, exception) {
        var $this = createThis(this);
        $this.i44_1 = operation;
        $this.j44_1 = requestUuid;
        $this.k44_1 = data;
        $this.l44_1 = errors;
        $this.m44_1 = extensions;
        $this.n44_1 = exception;
        $this.o44_1 = Companion_getInstance().f43_1;
        $this.p44_1 = false;
        return $this;
      }
      static r44(operation, requestUuid) {
        return this.q44(operation, requestUuid, null, null, null, null);
      }
      s44(executionContext) {
        // Inline function 'kotlin.apply' call
        this.o44_1 = this.o44_1.t44(executionContext);
        return this;
      }
      u44(data) {
        // Inline function 'kotlin.apply' call
        this.k44_1 = data;
        return this;
      }
      v44(errors) {
        // Inline function 'kotlin.apply' call
        this.l44_1 = errors;
        return this;
      }
      w44(exception) {
        // Inline function 'kotlin.apply' call
        this.n44_1 = exception;
        return this;
      }
      x44(extensions) {
        // Inline function 'kotlin.apply' call
        this.m44_1 = extensions;
        return this;
      }
      g43(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.j44_1 = requestUuid;
        return this;
      }
      y44(isLast) {
        // Inline function 'kotlin.apply' call
        this.p44_1 = isLast;
        return this;
      }
      c38() {
        var tmp1_operation = this.i44_1;
        var tmp2_requestUuid = this.j44_1;
        var tmp3_data = this.k44_1;
        var tmp4_executionContext = this.o44_1;
        var tmp0_elvis_lhs = this.m44_1;
        var tmp5_extensions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp6_errors = this.l44_1;
        var tmp7_exception = this.n44_1;
        var tmp8_isLast = this.p44_1;
        return new (ApolloResponse())(tmp2_requestUuid, tmp1_operation, tmp3_data, tmp6_errors, tmp7_exception, tmp5_extensions, tmp4_executionContext, tmp8_isLast);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloResponseClass;
function ApolloResponse() {
  if (ApolloResponseClass === VOID) {
    class $ {
      constructor(requestUuid, operation, data, errors, exception, extensions, executionContext, isLast) {
        this.z44_1 = requestUuid;
        this.a45_1 = operation;
        this.b45_1 = data;
        this.c45_1 = errors;
        this.d45_1 = exception;
        this.e45_1 = extensions;
        this.f45_1 = executionContext;
        this.g45_1 = isLast;
      }
      h45() {
        var tmp;
        if (this.v45()) {
          throw ApolloGraphQLException().u45(first(ensureNotNull(this.c45_1)));
        } else if (!(this.d45_1 == null)) {
          throw DefaultApolloException().n45('An exception happened', this.d45_1);
        } else {
          tmp = this.i45();
        }
        return tmp;
      }
      i45() {
        var tmp0_elvis_lhs = this.b45_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NoDataException().a46(this.d45_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      v45() {
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = this.c45_1;
        return !(this_0 == null || this_0.n1());
      }
      g44() {
        return Builder().q44(this.a45_1, this.z44_1, this.b45_1, this.c45_1, this.e45_1, this.d45_1).s44(this.f45_1).y44(this.g45_1);
      }
      toString() {
        var tmp = 'operationName=' + this.a45_1.operationName() + ', ';
        var tmp_0 = 'data=' + (this.b45_1 == null ? 'null' : this.a45_1.operationName() + '.Data') + ', ';
        var tmp0_safe_receiver = this.c45_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2();
        var tmp_1 = 'errors=' + toString(tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs) + ', ';
        var tmp_2;
        if (this.d45_1 == null) {
          tmp_2 = 'null';
        } else {
          var tmp2_elvis_lhs = getKClassFromExpression(this.d45_1).j1();
          tmp_2 = tmp2_elvis_lhs == null ? 'true' : tmp2_elvis_lhs;
        }
        return 'ApolloResponse(' + tmp + tmp_0 + tmp_1 + ('exception=' + tmp_2) + ')';
      }
    }
    initMetadataForClass($, 'ApolloResponse');
    ApolloResponseClass = $;
  }
  return ApolloResponseClass;
}
//region block: exports
export {
  Builder as Builder16nv925388a0q,
  ApolloResponse as ApolloResponse1aeginapbuksm,
};
//endregion

//# sourceMappingURL=ApolloResponse.mjs.map
